import { css } from "@emotion/react";
import { FC, ReactNode, useState } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { withVar } from "themes/helpers";

import { BreakdownTable, IBreakdownTableProps } from "./Breakdown/BreakdownTable";
import { getBreakdownPropsFromChartOptions } from "./helpers/break-down";
import {
  StyledIconWrapper,
  breakdownTableContainerStyles,
  headerStyles,
  headerTitleStyles,
} from "./styled/chart-break-down";

export type ISorted = { id: string; desc: boolean };
interface IChartBreakdownProps {
  chartTitle?: string;
  customTitle?: ReactNode;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartOptions?: any;
  loading?: boolean;
  exportFileName?: string;
  exportData?: (string | number)[][];
  disabledTotal?: boolean;
  onDataExported?(): void;
  valueParser?(value: unknown): ReactNode;
  breakdownProps?: Partial<IBreakdownTableProps>;
  breakdownData?: Partial<IBreakdownTableProps>;
  truncateData?: boolean;
  fallbackComponent?: ReactNode;
  disableExpand?: boolean;
  sort?: ISorted;
}

export const ChartBreakdown: FC<IChartBreakdownProps> = ({
  chartTitle,
  customTitle,
  chartOptions,
  disabledTotal,
  valueParser,
  breakdownData,
  truncateData,
  fallbackComponent,
  disableExpand,
  sort,
}) => {
  const [isBreakdownVisible, setBreakdownVisible] = useState(true);

  const handleBreakdownHeaderClick = (): void => setBreakdownVisible(!isBreakdownVisible);

  const breakdownProps = chartOptions
    ? // @ts-expect-error TS(2345)
      getBreakdownPropsFromChartOptions(chartOptions, valueParser, disabledTotal)
    : breakdownData;
  if (!breakdownProps) {
    return null;
  }

  return (
    <div
      css={[
        breakdownTableContainerStyles,
        !truncateData ? css({ "&:not(:last-child)": { margin: "0 -20px -29px -20px" } }) : undefined,
      ]}
    >
      <div css={headerStyles}>
        <div
          css={headerTitleStyles}
          className={disableExpand ? "disabled" : ""}
          onClick={!disableExpand ? handleBreakdownHeaderClick : undefined}
        >
          <StyledIconWrapper isOpen={isBreakdownVisible} disableExpand={disableExpand}>
            <Icon
              name={IconsEnum.ArrowRightShort}
              width="12px"
              height="12px"
              fill={withVar(DesignToken.ActionPrimaryDefault)}
            />
          </StyledIconWrapper>
          <div>{customTitle ? customTitle : <>{chartTitle} breakdown</>}</div>
        </div>
      </div>
      {breakdownProps && (
        <div>
          {!fallbackComponent ? (
            <BreakdownTable
              {...breakdownProps}
              sort={sort}
              uniqClassName={chartTitle?.split(" ").join("-") ?? "chart-breakdown"}
              isOpen={isBreakdownVisible}
              truncateData={truncateData && isBreakdownVisible}
            />
          ) : (
            fallbackComponent
          )}
        </div>
      )}
    </div>
  );
};
